import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import DealersAgencies from '../../dealer/components';
import SpecialOrders from './specialOrders';
import StockOrder from './fromStock';
import EmergingOrder from './emerging';
import Management from './management';
import GroupedManagement from './groupedManagement';
import Tracking from './tracking';
import PossDownload from './possDownload';
import LostSalesReport from './lostSalesReport';
import ImmobilizedOrders from './immobilized';
import DealerOrdersEtaManagement from './etaManagement';

export const dealerOrdersRoutes = [
  {'component': <DealersAgencies />, 'path': paths.DealersAgencies},
  {'component': <SpecialOrders />, 'path': paths.DealerSpecialOrders},
  {'component': <StockOrder />, 'path': paths.DealerStockOrders},
  {'component': <EmergingOrder/>, 'path': paths.DealerEmergingOrders},
  {'component': <Tracking />, 'path': paths.DealerOrdersTracking},
  {'component': <Management />, 'path': paths.DealerOrdersManagement},
  {'component': <GroupedManagement />, 'path': paths.DealerOrdersGroupedManagement},
  {'component': <PossDownload />, 'path': paths.DealerPossDownload},
  {'component': <LostSalesReport />, 'path': paths.DealerLostSalesReport},
  {'component': <ImmobilizedOrders />, 'path': paths.DealerOrdersImmobilized},
  {'component': <DealerOrdersEtaManagement />, 'path': paths.DealerOrdersEtaManagement},
];
